module.exports = __webpack_public_path__ + "static/img/btn2.43086b4.png";


//////////////////
// WEBPACK FOOTER
// ./static/btn2.png
// module id = rn5C
// module chunks = 1